import React from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from './misc';

// Define the first React component
export default function MenComponent() {
    const [loading, setLoading] = React.useState(true)
    const [empty, setIsEmpty] = React.useState(false)
    const [linkitems, setLinkItems] = React.useState([])

    const shuffleArray = (array) => {
        const newArray = [...array]; // Create a copy of the array to avoid mutating the original
        for (let i = newArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
    };

    React.useEffect(function () {
        fetchData("/api/getmenfiles").then((data) => {
            console.log("Response:", data)
            if (data.images.length !== 0) {
                console.log("The Response:", data)
                setLinkItems(data.images)
                setLoading(false)
            } else {
                console.log("The Response:", data)
                setLinkItems(data.images)
                setLoading(false)
                setIsEmpty(true)
            }
        }).catch((error) => {
            console.error("Error fetching auth codes:", error);
            throw error;
        })
    }, [])

    React.useEffect(() => {
        // Initial shuffle when the component mounts
        // Set up the interval to shuffle every 30 seconds (30000 milliseconds)
        const intervalId = setInterval(() => {
          setLinkItems(shuffleArray(linkitems));
        }, 3000);
    
        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, [linkitems]);

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-1 place-items-center">
            {loading
                ? null
                : <>
                    {empty
                        ? <p className="text-white text-base">No men just yet.</p>
                        : <>
                            {linkitems.map((item) => (
                                <Link href="/login">
                                    <img className="img-fluid" src={item.link}/>
                                </Link>
                            ))}
                          </>
                    }
                  </>
            }
        </div>
    )
}